import { IoArrowUpOutline, IoArrowDownOutline } from 'react-icons/io5';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

const CardMedium = ({ amount, color, title, value }) => {
  const isGreen = color === 'green';
  return (
    <div className={styles.card}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.bottom}>
        <h1 className={styles.amount}>{amount}</h1>
        <div
          className={`${styles.indicator} ${
            isGreen ? styles.indicatorGreen : styles.indicatorRed
          }`}
        >
          <h1 className={styles.indicatorValue}>{value}</h1>
          {isGreen ? (
            <IoArrowUpOutline size={18} />
          ) : (
            <IoArrowDownOutline size={18} />
          )}
        </div>
      </div>
    </div>
  );
};

CardMedium.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  color: PropTypes.string.isRequired,
  title: PropTypes.string,
  value: PropTypes.string,
};

export default CardMedium;
